import { useState } from "react";
import { FmHeaderSearchProps } from "domains/file-manager/components/FileManagerV2/FmHeaderSearch";

export default function useAssetSearch() {
  const [search, setSearch] = useState<FmHeaderSearchProps["value"]>("");

  return {
    searchQueryArgs: {
      query: search,
    },
    fmHeaderSearchProps: {
      value: search,
      onChange: setSearch,
    },
  };
}
